import { makeStyles } from 'tss-react/mui';
import React, { useRef } from 'react';
import EDIconButton from '../../../../../../../../../../../../BaseComponents/Buttons/IconButton/EDIconButton';
import EDFormControlLabel from '../../../../../../../../../../../../BaseComponents/FormControlLabel/EDFormControlLabel';
import EDPopover from '../../../../../../../../../../../../BaseComponents/Popover/EDPopover';
import EDSwitch from '../../../../../../../../../../../../BaseComponents/Switch/EDSwitch';
import { IColumnTemplate } from '../../../Queries/AvailableColumnTemplatesHandler';
import { templateCanHavePreviousYear } from '../../Utils/EkonomiskAnalysColumnSelect.utils';

interface IProps {
  open: boolean;
  onClick: () => void;
  flipColumnSign: boolean;
  onFlipSignSwitchChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => void;

  prevYearCols: boolean;
  onPrevYearColsSwitchChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => void;

  selectedTemplate: string;
  availableColumnTemplates: IColumnTemplate[];
}

const useStyles = makeStyles()({
  popover: {
    padding: '24px',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
});

const EkonomiskAnalysColumnSelectTemplateActions: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  const { classes, cx } = useStyles();

  return (
    <>
      <EDIconButton
        icon="more_vert"
        tooltip="Inställningar för kolumnmall"
        onClick={props.onClick}
        ref={buttonRef}
      />
      <EDPopover
        open={props.open}
        anchorEl={buttonRef.current}
        onClose={props.onClick}
      >
        <div className={cx(classes.container, classes.popover)}>
          <EDFormControlLabel
            value="Vänd tecken"
            control={
              <EDSwitch
                checked={props.flipColumnSign}
                onChange={props.onFlipSignSwitchChange}
              />
            }
            label="Vänd tecken"
          />
          <EDFormControlLabel
            value="Föregående år"
            disabled={
              !templateCanHavePreviousYear(
                props.selectedTemplate,
                props.availableColumnTemplates
              )
            }
            disabledReason={
              !templateCanHavePreviousYear(
                props.selectedTemplate,
                props.availableColumnTemplates
              )
                ? 'Föregående år ej tillgängligt för vald kolumnmall'
                : undefined
            }
            control={
              <EDSwitch
                checked={props.prevYearCols}
                onChange={props.onPrevYearColsSwitchChange}
              />
            }
            label="Inkludera föregående år"
          />
        </div>
      </EDPopover>
    </>
  );
};

export default EkonomiskAnalysColumnSelectTemplateActions;
